import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TariffBuyModalComponent} from "../../../pages/tariff/tariff-buy-modal/tariff-buy-modal.component";

@Component({
  selector: 'app-playground',
  standalone: true,
  imports: [TariffBuyModalComponent],
  templateUrl: './playground.component.html',
  styleUrl: './playground.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})
export class PlaygroundComponent {}
